// import Image from 'next/legacy/image'
import clsx from 'clsx'

import Text from '~/components/Text/Text'

// import { useInvestors } from './useInvestors'
import styles from './AboutInvestors.module.sass'

// const InvestorPhoto = ({src, name}: {src: string, name: string}) =>
//   <Image
//     src={src} alt={name} width='100%' height='100%' layout='responsive'
//     className={styles.personPhoto}
//   />

// const InvestorLogo = ({src, name, className}: {src: string, name: string, className: string}) =>
//   <img src={src} alt={name} className={clsx(styles.investorLogo, className)} />

const AboutInvestors: React.FC = () => {
  // const investors = useInvestors()

  return (
    <div className={clsx('site-grid site-container', styles.section)}>
      <div
        className={clsx('col-span-full md:col-start-2 md:col-end-8 lg:col-start-4 lg:col-end-10', styles.textSection)}
      >
        <Text variant='subheading' fontSize={[28, 28, 40]}>
          Our investors
        </Text>
        <Text fontSize={[18, 14, 18]} className={styles.description}>
          We’ve raised a $6.5M Seed Round from Coatue, Blossom Capital, the founders of Intercom,
          Checkout.com, Monzo, etc.
          {/*We’re backed by some of the best investors and angels,
          including founders of Intercom, Checkout.com, Monzo, and operators from Wise, and Klarna.*/}
        </Text>
      </div>
      {/*
      <div
        className={clsx(
          'col-span-full grid grid-cols-2 gap-x-[16px] gap-y-[48px]',
          'md:col-start-2 md:col-end-8 md:grid-cols-3',
          'lg:place-items-center lg:col-start-2 lg:col-end-12 lg:gap-x-[unset] lg:gap-y-[80px]'
        )}
      >
        {investors.map(({ photoSrc, lightPhotoSrc, firmName, firmUrl, name, title, logoSrc, lightLogoSrc }) => (
          <div key={title} className={styles.personTile}>

            <div className={clsx({'hidden dark:block': lightPhotoSrc})}>
              <InvestorPhoto src={photoSrc} name={name}/>
            </div>
            {lightPhotoSrc &&
              <div className='dark:hidden'>
                <InvestorPhoto src={lightPhotoSrc} name={name}/>
              </div>
            }

            <Text fontSize={[18, 14, 18]} className={styles.personName}>
              {name}
            </Text>
            <Text fontSize={[15, 14, 15]} className={styles.personTitle}>
              {title}
            </Text>

            <Link href={firmUrl} title={firmName}>
              <InvestorLogo src={lightLogoSrc} name={firmName} className='dark:hidden text-black'/>
              <InvestorLogo src={logoSrc} name={firmName} className='hidden dark:block text-white'/>
            </Link>
          </div>
        ))}
      </div>
      */}
    </div>
  )
}

export default AboutInvestors
